export default __webpack_public_path__ + "static/media/hackcu.34ee2fac.svg";